import { request } from '@/shared/api/request'

export const getXml = (payload) => {
	return request({ url: 'colcontract/industryAgreement/get/xml', method: 'POST', data: payload })
}
